import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowBackSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
        <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.2"
              d="M17 22.5 6.85 12.35a.5.5 0 0 1 0-.7L17 1.5"></path>
    </svg>
)

const ArrowBackIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowBackSvg}
    </SvgIcon>
)

export default ArrowBackIcon